import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const WarningModal = ({ open, onClose,message }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '8px',
                    padding: 0,
                    minHeight: 'fit-content',
                    maxHeight: 'fit-content'
                }
            }}
        >
            <DialogTitle 
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '0 16px',
                    backgroundColor: '#102A62',
                    margin: 0,
                    width: '100%',
                    height: '50px',  // Fixed header height
                    boxSizing: 'border-box',
                    textAlign: 'center'

                }}
            >
                <Typography
                    sx={{
                        color: '#FFFFFF',
                        fontFamily: 'Montserrat',
                        fontWeight: 600,
                        fontSize: '20px',
                        textAlign: 'center'
                    }}
                >
                    Warning
                </Typography>
                <IconButton onClick={onClose} sx={{ color: '#FFFFFF', padding: 0 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent 
                sx={{ 
                    padding: '20px 20px 20px 20px',  // 20px horizontal padding
                    overflow: 'hidden',
                    marginTop: '20px',
                }}
            >
                <Typography
                    sx={{
                        color: '#000000DE',
                        fontFamily: 'Montserrat',
                        fontSize: '16px',
                        lineHeight: '24px'
                    }}
                >
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions 
                sx={{ 
                    padding: '0 20px 20px 20px',  // 20px bottom and horizontal padding
                    justifyContent: 'flex-end'
                }}
            >
                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{
                        backgroundColor: '#102A62',
                        color: 'white',
                        textTransform: 'none',
                        fontFamily: 'Montserrat',
                        padding: '6px 16px',
                        '&:hover': {
                            backgroundColor: '#102A62'
                        }
                    }}
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WarningModal;